import { Component, OnInit } from '@angular/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';
//import { single } from './data';
import { AnalyticsService } from './analytics.service';
//import { AnalyticsModule } from './analytics.module';
import { UnattendedChartComponent } from './charts/unattended-chart.component';
import { ItemValue } from '../ResourceModels/analytics/ItemValue';
import { groupBy } from './data.helper';
//import { single, multi, unattended, unattended1 } from './data';

@Component({
  selector: 'analytics',
  templateUrl: './analytics.component.html',
  styleUrls: [ './analytics.component.scss' ]
})
export class AnalyticsComponent implements OnInit {     
    receivedData: any[];
    columns: any[] = [
        { columnDef: 'clinic', header: 'Name', dataName: row => `${row.clinic}` },
        { columnDef: 'date', header: 'Oldest Unatended Cases', dataName: row => `${row.name}` },
        { columnDef: 'value', header: 'Unattended Cases', dataName: row => `${row.Value}` }
      ];
      //["name","value","clinic"];
    showTableResults: true;

    receivedDataMessages: any[];
    columnsMessages: any[] = [
      { columnDef: 'type', header: 'Type', dataName: row => `${row.type}` },
      { columnDef: 'date', header: 'Oldest Unatended Cases', dataName: row => `${row.name}` },
      { columnDef: 'value', header: 'Number SMS', dataName: row => `${row.Value}` }
    ];

    constructor(private analyticsService: AnalyticsService) {
        
    }   

  ngOnInit() {     
    //this.getUnattendedCases(); 
    this.getNumberMessagesSended();  
  } 
  
  getUnattendedCases(): void {
    this.analyticsService.getUnattendedCases()
        .subscribe(results => { 
            console.log(results);
            //var groups = groupBy(results, {keys: ['clinic'], sum: ['Value']});
            //console.log(groups);
            this.receivedData = results;
        });
  }

  getNumberMessagesSended(): void {
    this.analyticsService.getNumberMessagesSended()
        .subscribe(results => { 
            console.log(results);           
            this.receivedDataMessages = results;
        });
  }
  viewItem(event): void {

  }

  updatePagination(event): void {

  }
}
